import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DoctorDrugModal from "../../DoctorDrugModal/DoctorDrugModal.component";
import { IDoctor } from "../../../interfaces/api";
import { FullWidthLine, ListSection } from "../../../shared";
import { AiOutlineLeft } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

const DoctorsPart = () => {
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [planDoctors, setPlanDoctors] = useState<IDoctor[]>([]);
  const [showMessage] = useState<boolean>(false);

  const stepModal = true;

  const confirmDoctors = (data: IDoctor[]) => {
    setPlanDoctors((prevDoctors) => {
      const newDoctors = data.filter((newDoctor) => {
        return !prevDoctors.some(
          (existingDoctor) => existingDoctor.npi === newDoctor.npi
        );
      });
      return [...prevDoctors, ...newDoctors];
    });
  };

  useEffect(() => {
    sessionStorage.setItem(`planDoctorsChoose`, JSON.stringify(planDoctors));
  }, [planDoctors]);

  const openDoctorModal = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setOpenModal(true);
  };

  const handleRemoveDoctor = (
    providerID: string,
    npi: string,
    provider: boolean
  ) => {
    const updatedComponentList = planDoctors.filter((doctor) => {
      const shouldRemoveDoctor =
        doctor.npi === npi &&
        doctor.ahRecords.some((record) => record.providerID === providerID);

      return !shouldRemoveDoctor;
    });
    provider && sessionStorage.removeItem("doctorProviderID");
    setPlanDoctors(updatedComponentList);
  };
  const Continue = () => {
    if (
      planDoctors[0]?.ahRecords[0]?.providerCategory[0] ===
        "Primary Care Provider (PCP)" &&
      planDoctors[0]?.ahRecords[0]?.providerID
    ) {
      sessionStorage.setItem(
        "doctorProviderID",
        planDoctors[0].ahRecords[0].providerID
      );
    }
    navigate("/recommended-plans");
  };

  return (
    <>
      <div className="grid-container">
        <div className="show-for-small-only">
          <div style={{ padding: "56px 0px 40px 0px" }}>
            <h3
              style={{
                color: "#003A5D",
                fontSize: 39,
                fontWeight: "600",
                lineHeight: "42px",
                textTransform: "uppercase",
              }}
            >
              Add your Doctors
            </h3>
            <div style={{ paddingTop: 16, paddingBottom: 40, fontSize: 25 }}>
              <div>
                Explore our network and check if your doctors are covered.
              </div>
              <br></br>
              <div>Need help finding a doctor?</div>
              <div>
                Give us a call.{" "}
                <a
                  style={{
                    textDecoration: "underline",
                    color: "#1B54C2",
                    fontWeight: "500",
                  }}
                  href="tel:18882938272"
                >
                  1-888-293-8272
                </a>{" "}
                (TTY: 711). We're here to help!
              </div>
            </div>
            <div style={{ paddingBottom: 16 }}>
              <button
                type="button"
                className="button hollow"
                style={{
                  width: "100%",
                  boxShadow: "0px 8px 8px rgba(0, 0, 0, 0.1)",
                }}
                onClick={openDoctorModal}
              >
                Search Doctors
              </button>
            </div>
            <ListSection
              doctors={planDoctors}
              onRemove={handleRemoveDoctor}
              stepModal={stepModal}
              showMessage={showMessage}
            />
          </div>
        </div>
        <div className="hide-for-small-only" style={{ padding: "56px 100px" }}>
          <div>
            <h3
              style={{
                color: "#003A5D",
                fontSize: 39,
                fontWeight: "600",
                lineHeight: "42px",
                textTransform: "uppercase",
              }}
            >
              Add your Doctors
            </h3>
            <div style={{ paddingTop: 16, paddingBottom: 40, fontSize: 25 }}>
              <div>
                Explore our network and check if your doctors are covered.
              </div>
              <br></br>
              <div>Need help finding a doctor?</div>
              <div>
                Give us a call.{" "}
                <a
                  style={{
                    textDecoration: "underline",
                    color: "#1B54C2",
                    fontWeight: "500",
                  }}
                  href="tel:18882938272"
                >
                  1-888-293-8272
                </a>{" "}
                (TTY: 711). We're here to help!
              </div>
            </div>
            <div style={{ paddingBottom: 16 }}>
              <button
                type="button"
                className="button hollow"
                style={{
                  minWidth: "329px",
                  boxShadow: "0px 8px 8px rgba(0, 0, 0, 0.1)",
                }}
                onClick={openDoctorModal}
              >
                Search Doctors
              </button>
            </div>
            <ListSection
              doctors={planDoctors}
              onRemove={handleRemoveDoctor}
              stepModal={stepModal}
              showMessage={showMessage}
            />
          </div>
        </div>
        <FullWidthLine />
        <div
          className="hide-for-small-only"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "24px 0",
          }}
        >
          <Link
            to={{
              pathname: "/get-recommendations/preferences",
            }}
            style={{ textDecoration: "none" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: 25,
                fontWeight: 500,
                lineHeight: "24px",
                textDecoration: "underline",
                color: "#1B54C2",
              }}
            >
              <AiOutlineLeft style={{ marginRight: "5px" }} />
              Previous step
            </div>
          </Link>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Link
              to={{
                pathname: "/recommended-plans",
              }}
            >
              <div
                style={{
                  fontSize: 25,
                  fontWeight: 500,
                  lineHeight: "24px",
                  textDecoration: "underline",
                  color: "#1B54C2",
                  paddingRight: 25,
                  cursor: "pointer",
                }}
              >
                Skip this step
              </div>
            </Link>
            <button
              type="button"
              disabled={planDoctors.length < 1}
              style={{
                margin: 0,
                backgroundColor: planDoctors.length < 1 ? "#CACACA" : "",
              }}
              className="button"
              onClick={Continue}
            >
              Continue
            </button>
          </div>
        </div>
        <div
          className="show-for-small-only"
          style={{ paddingTop: 24, paddingBottom: 40 }}
        >
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Link
              to={{
                pathname: "/recommended-plans",
              }}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                textDecoration: "underline",
                color: "#1B54C2",
                paddingRight: 25,
                cursor: "pointer",
                width: "50%",
                fontSize: 18,
              }}
            >
              Skip this step
            </Link>
            <button
              type="button"
              style={{
                margin: 0,
                width: "50%",
                backgroundColor: planDoctors.length < 1 ? "#CACACA" : "",
              }}
              className="button"
              onClick={Continue}
            >
              Continue
            </button>
          </div>
          <Link
            to={{
              pathname: "/get-recommendations/preferences",
            }}
            style={{ textDecoration: "none" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: 32,
                fontSize: 18,
                fontWeight: 500,
                lineHeight: "24px",
                textDecoration: "underline",
                color: "#1B54C2",
              }}
            >
              <AiOutlineLeft style={{ marginRight: "5px" }} />
              Previous step
            </div>
          </Link>
        </div>
      </div>
      {openModal && (
        <DoctorDrugModal
          setOpenModal={setOpenModal}
          confirmDoctors={confirmDoctors}
          actualData={planDoctors}
        />
      )}
    </>
  );
};

export default DoctorsPart;
